import React from 'react'
import { ReactComponent as ProgressiveAlphaIndicator } from '@sketch/icons/progressive-alpha'
import styled from 'styled-components'

const ProgressiveAlphaIndicatorStyled = styled(ProgressiveAlphaIndicator)`
  height: 5px;
  width: 26px;
`

const ProgressiveAlphaContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export interface ProgressiveAlphaProps {
  from: number
  to: number
}

export const ProgressiveAlpha: React.FC<ProgressiveAlphaProps> = ({
  from,
  to,
}) => {
  return (
    <ProgressiveAlphaContainer>
      {from}% <ProgressiveAlphaIndicatorStyled /> {to}%
    </ProgressiveAlphaContainer>
  )
}
